import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import { H2 } from 'components/common/Text/Text'
import Media from 'components/common/Media'
import Mixin from 'components/common/Mixin'
import kebabCase from 'lodash/kebabCase'
import { dynamicDataAttribute } from 'helpers/utils'

const StoreAmenities = ({ header = 'Store Amenities', amenitiesIcons = []}) =>
  <React.Fragment>
    {
      amenitiesIcons.length > 0 &&
      <Wrapper>
        <SectionName { ...dynamicDataAttribute(`${kebabCase(header)}-heading`) } centered headline noMargin>
          { header }
        </SectionName>
        <SectionColumn>
          <SectionList>
            {
              amenitiesIcons
                .map(({ title, icon }, index) =>
                  <SectionListItem data-at-amenity key={ index } bolder>
                    { title }
                  </SectionListItem>)
            }
          </SectionList>
        </SectionColumn>
      </Wrapper>
    }
  </React.Fragment>

export default StoreAmenities

StoreAmenities.propTypes = {
  amenitiesIcons: PropTypes.arrayOf(PropTypes.shape),
  header: PropTypes.string
}

StoreAmenities.type = 'BOTStoreAmenities'

const Wrapper = styled.div`
  min-height: 100px;
  background-color: ${Theme.colors.off_white};
  padding: 20px 0;
  ${Mixin.clearFix()};
`

const SectionName = styled(H2)`
  padding: 25px 0;
  font-size: 30px;
`

const SectionColumn = styled.div`
  ${Mixin.responsive('padding', '0', '20px')}
  ${Media.desktop`
    width: 500px;
    margin: 0 auto;
  `}
`

const SectionList = styled.ul`
  list-style-type: disc;
`

const SectionListItem = styled.li`
  width: 50%;
  float: left;
  list-style-type: disc;
`
